import clsx from 'clsx';
import { TGetOffersResponse } from 'lendingApi/lapiOverrides.types';
import { ContinueToDocuments } from '../ContinueToDocuments/ContinueToDocuments';
import { IconWithText } from '../IconWithText/IconWithText';
import { ProbabilityPill } from '../ProbabilityPill/ProbabilityPill';
import styles from '../ProductOffers.module.css';
import { FlexiLoanLogo } from './FlexiLoanLogo';

type TProps = {
  offers: TGetOffersResponse['data']['offers'];
};

export const IndicativeOffer = ({ offers }: TProps) => {
  return (
    <section className={styles.productOffer}>
      <div className={clsx(styles.group, styles.image)}>
        <FlexiLoanLogo />
      </div>
      <div className={clsx(styles.group, styles.durations)}>
        <ul>
          <li>
            <IconWithText icon="calendarOutline" text="Up to 12 months" />
          </li>
          <li>
            <IconWithText icon="calendarOutline" text="Up to  24 months" />
          </li>
        </ul>

        <ul>
          {offers.map(({ offer_id, probability_of_offer }) =>
            probability_of_offer ? (
              <li key={offer_id}>
                <ProbabilityPill probability={probability_of_offer} />
              </li>
            ) : null,
          )}
        </ul>
      </div>
      <div className={clsx(styles.group, styles.points)}>
        <ul>
          <li>
            <IconWithText icon="timerOutline" text="Decision in 48 hrs" />
          </li>
          <li>
            <IconWithText icon="filePlusInside" text="Documents required" />
          </li>
        </ul>
        <ContinueToDocuments />
      </div>
    </section>
  );
};
